import { Flex, FormInput } from '@sparrowengg/twigs-react';
import { WebhookStateValues } from 'features/apps/add-apps/types';
import { UseFormRegister } from 'react-hook-form';
import { AuthFields } from './token-authentication';

const OauthAuthentication = ({
  register,
  errors
}: {
  register: UseFormRegister<WebhookStateValues>;
  errors: any;
}) => {
  return (
    <Flex flexDirection="column" gap="$8" css={{ marginTop: '$3' }}>
      <AuthFields errors={errors} register={register} />
      <FormInput
        size="lg"
        label="Scopes (Optional)"
        {...register('properties.headers.scopes')}
      />
    </Flex>
  );
};

export default OauthAuthentication;
